import { Vue, Component, Emit, Prop } from 'vue-property-decorator';

@Component
export default class CodeEditorActions extends Vue {
	@Prop({
		default: true
	})
	isEditorVisible!: boolean;

	@Emit('toggleEditorVisibility')
	handleEditorToggle(): void {}

	@Emit('copyCode')
	handleCopyCode(): void {}
}
